import { SET_ERROR, SET_IS_LOADING, SET_SUCCESS } from "./types";


export const setError = (message) => {
    return {
        type: SET_ERROR,
        payload: message
    }
}


export const setSuccess = (message) => {
    return {
        type: SET_SUCCESS,
        payload: message
    }
}

export const setIsLoading = (isLoading) => {
    return {
        type: SET_IS_LOADING,
        payload: isLoading
    }
}
